import { getEnv, hasEnv } from "../helpers/env.ts";
import { AssetImageFormat, AssetMode } from "./asset.interface";

export const defAssetQuality = 70;

export function getImgUrl(mode: AssetMode, id: number, filename = '', width: number = 0, height: number = 0, quality = defAssetQuality) {
	const prefix = (hasEnv('PUBLIC_ASSET_HOST') ? getEnv('PUBLIC_ASSET_HOST') : '');

	if (!hasEnv('PUBLIC_ASSET_HOST')) {
		console.info('missing PUBLIC_ASSET_HOST');
	}

	return prefix + getImgUrlRelative(mode, id, filename, width, height, quality);
}

export function getImgUrlRelative(mode: AssetMode, id: number, filename = '', width: number = 0, height: number = 0, quality = defAssetQuality) {
	if (quality === null) {
		quality = defAssetQuality;
	}

	switch (mode) {
		case AssetMode.Full:
			return '/asset/' + id + "/" + width + '-' + height + '-' + quality + '/' + filename;
		case AssetMode.Thumb:
			return '/asset/crop/' + id + "/" + width + '-' + height + '-' + quality + '/' + filename;
		case AssetMode.Media:
			return '/asset/media/' + id + "/" + filename;
	}
}

export function getFileNameWithoutExtension(filename: string = '') {
	return filename.substring(0, filename.lastIndexOf(('.'))) || filename;
}

export function getFileExtensionFromFilename(filename: string = '') {
	return filename.substring(filename.lastIndexOf('.') + 1, filename.length);
}

export function getAssetImageFormatFromFileExtension(extension: string = '') {
	switch (extension.toLowerCase()) {
		case 'png': return AssetImageFormat.Png;
		case 'webp': return AssetImageFormat.Webp;
		case 'jpg':
		case 'jpeg':
			return AssetImageFormat.Jpg;
	}

	return null;
}
